import React, { Component } from 'react'
import SingleSong from './SingleSong'
import styles from './SongList.module.css'

class SongList extends Component {
  render() {
    const { songList } = this.props
    return (
      <div className={styles.SongList}>
        {[...songList]
          .reverse()
          .map((item, i) => (
            <SingleSong {...item} key={item.node.wordpress_id} />
          ))}
      </div>
    )
  }
}

export default SongList



// WEBPACK FOOTER //
// ./src/components/EightRooms/SongList/SongList.js